/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserRoleResponse } from './search-user-role-response';
import { SearchUserStatusResponse } from './search-user-status-response';


export interface SearchUsersResponseItem { 
    id: string;
    login: string;
    email?: string | null;
    role?: SearchUserRoleResponse;
    status: SearchUserStatusResponse;
    lockoutEndDate?: string | null;
    lastLoginDate?: string | null;
    blockedDate?: string | null;
    blockReason?: string | null;
    blockedByAdmin?: string | null;
    createdDate: string;
}

